// AuthUtil stub for EAS frontend.
// EAS is an anonymous funnel — no Cognito, no logged-in users.
// HttpService and UserService import these helpers; they always return empty.

export async function getRawIdTokenAsString(): Promise<string> {
    return '';
}

export async function getRawIdTokenWithGroups(): Promise<[string, string[]]> {
    return ['', []];
}
